import { Component, OnInit, Input, Host, ViewChild } from '@angular/core';

import { AppComponent } from './../../app.component';

@Component({
  selector: 'janela',
  templateUrl: './janela.component.html',
  styleUrls: ['./janela.component.scss'],
})
export class JanelaComponent implements OnInit {

  @Input() titulo: string;

  constructor() {}

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/janela/janela.component.ts